export default __webpack_public_path__ + "static/media/gif-modal.437970e7.svg";